import { Reveal, SectionHead, Em } from "@/components/Reveal";

const shots = [4, 6, 8];

export const SecondProofSection = () => (
  <section data-testid="second-proof-section" className="relative overflow-hidden">
    <div
      aria-hidden="true"
      className="absolute inset-x-0 top-1/2 h-40 -translate-y-1/2 bg-cover bg-center opacity-30"
      style={{ backgroundImage: "url(/assets/leopard.jpg)" }}
    />
    <div className="relative mx-auto max-w-5xl px-5 py-20 sm:py-28">
      <SectionHead eyebrow="MORE WORDS FROM THE COMMUNITY" center>
        WHAT HAPPENS WHEN YOU
        <br />
        STOP WAITING FOR <Em>SOMEDAY?</Em>
      </SectionHead>

      <div className="flex items-start justify-center gap-0" data-testid="second-proof-grid">
        {shots.map((n, i) => (
          <Reveal key={n} delay={i * 0.1} className={i === 1 ? "z-10 -mx-6 sm:-mx-10" : ""}>
            <img
              src={`/assets/testi/testi-${n}.jpg`}
              alt="Real message from a member of Dasha Love's community"
              loading="lazy"
              data-testid={`proof-${n}`}
              className={`w-40 border border-white/15 bg-ink shadow-[0_30px_60px_rgba(0,0,0,0.6)] transition-transform duration-500 hover:scale-[1.03] sm:w-60 ${
                i === 0 ? "rotate-[-4deg] translate-y-6" : i === 2 ? "rotate-[4deg] translate-y-6" : "z-10"
              }`}
            />
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-14 text-center">
        <p className="mx-auto max-w-md font-mono text-[10px] leading-relaxed tracking-[0.15em] text-cream/35">
          INDIVIDUAL EXPERIENCES VARY. REAL MESSAGES — NAMES AND HANDLES REMOVED FOR PRIVACY.
        </p>
      </Reveal>
    </div>
  </section>
);
